import React, { useState, useEffect } from 'react';
import './index.less';
import apis from '../../api';
import goto from '@/common/goto';
import { withRouter } from 'react-router-dom';
import { Carousel } from 'antd';
import ComponentLog from '@/components/component-log';
import getBannerUrl from '@/common/goto/banner-url.js';

export default withRouter(function ActivityBanner() {
  const [banner, setBanner] = useState([]);
  useEffect(() => {
    apis
      .newBannerList({
        position: 4,
        // status: 1,
        // valid: 1
      })
      .then((res) => {
        if (res.ret === '0' && res.data) {
          setBanner(res?.data?.data || []);
        }
      });
  }, []);

  const handleClick = (item) => {
    const { clickEvent, planCode, jumpUrl, questionnaireUrl } = item;
    switch (clickEvent) {
      case 1:
        goto.merchantActivityDetail(planCode).push();
        break;
      case 2:
        window.open(jumpUrl);
        break;
      case 3:
        window.open(getBannerUrl(item));
        break;
      case 4:
        window.open(getBannerUrl(item));
        break;
      case 5:
        window.open(questionnaireUrl);
        break;
      default:
        return;
    }
  };

  return banner && banner.length > 0 ? (
    <Carousel
      autoplay
      dots={{ className: 'dotsClass' }}
      autoplaySpeed={5000}
      speed={1000}
      className="activity-banner-fa"
    >
      {banner.map((item, index) => {
        return (
          <ComponentLog key={index}>
            <img
              src={item.imageUrl}
              className="activity-banner"
              clstag="yx_center|workbench_banner"
              onClick={() => handleClick(item)}
            />
          </ComponentLog>
        );
      })}
    </Carousel>
  ) : null;
});
